import {TypographyVariant} from '@mui/material'
import {ColDef, GridOptions, SelectionChangedEvent} from 'ag-grid-community'
import {OcAgGrid, OcAgGridDefaultClassName} from '../AgGrid'

/**
 * Properties of one AgGrid of TransferList
 */
export interface OcTransferListGridProps<T> {
    data: T[]
    gridOptions?: GridOptions<T>
    columnDefs?: ColDef<T>[]
    title?: string
    titleVariant?: TypographyVariant
    transfer: (item: T) => void
    move?: (item: T, toIndex: number) => void
    orderableWithButtons?: boolean
    orderableWithDragAndDrop?: boolean
    className?: string
    quickSearch?: boolean
}

interface OcTransferListGridPropsPrivate<T> {
    setSelectedRows: (rows: T[]) => void
}

export function OcTransferListGrid<T>(props: OcTransferListGridProps<T> & OcTransferListGridPropsPrivate<T>) {
    const {data, gridOptions, columnDefs, className, setSelectedRows} = props

    return (
        <OcAgGrid
            rowData={data}
            gridOptions={gridOptions}
            columnDefs={columnDefs}
            className={className || OcAgGridDefaultClassName}
            onSelectionChanged={(event: SelectionChangedEvent) => setSelectedRows(event.api.getSelectedRows() as T[])}
        />
    )
}
